'use client';

import { ModuleRegistry } from 'ag-grid-community';
import { 
  AllEnterpriseModule,
  SetFilterModule
} from 'ag-grid-enterprise';

// Register AG Grid Modules
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  SetFilterModule
]);

export function AGGridProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
} 